module.exports = __webpack_public_path__ + "img/Somalia.0dd7ceb5.svg";